import { tryParseInt } from '@witkac/utils/tryParseInt';
import { Route } from 'vue-router';

import { TableName } from '@/enums/tableName';
import store from '@/store/store';
import { prepareQuery } from './prepareQuery';

/**
 * Pobiera listę faktur
 *
 * @export
 * @param {Route} route
 * @returns
 */
export function getInvoicesList(route: Route) {
  return store.dispatch('invoice/list', getInvoiceFilters(route));
}

/**
 * Lista grup faktur
 *
 * @export
 * @param {Route} route
 * @return
 */
export function getInvoiceGroupsList(route: Route) {
  return store.dispatch('invoice/listWithDocument', getInvoiceFilters(route));
}

/**
 * Filtry faktur
 *
 * @export
 * @param {Route} route
 * @return
 */
export function getInvoiceFilters(route: Route) {
  return {
    ...prepareQuery(route),
    nip: route.query.nip,
    number: route.query.number,
    date: route.query.date,
    entityType: TableName.document,
    entityId: route.params.documentId ? route.params.documentId.toString() : undefined,
    procedureId: tryParseInt(route.params.procedureId),
    count: -1
  };
}
